import { MailingActionTypes } from "./actionTypes";

export const MailingActionCreators = {
    getMailingLists: ({ page, top, search, subsidiaries, status })  => ({
        type: MailingActionTypes.GET_MAILING_LISTS,
        payload: {
            page,
            top,
            search,
            subsidiaries,
            status
        }
    }),

    getMailing: mailingID => ({
        type: MailingActionTypes.GET_MAILING_LIST,
        payload: {
            mailingID
        }
    }),

    getMailingTypes: () => ({
        type: MailingActionTypes.GET_MAILING_LISTS_TYPES
    }),

    getSubsidiaries: () => ({
        type: MailingActionTypes.GET_SUBSIDIARIES
    }),

    updateMailingLists: mailingList => ({
        type: MailingActionTypes.UPDATE_MAILING_LISTS,
        payload: {
            mailingList
        }
    }),

    editMailingList: ({mailingList, id }) => ({
        type: MailingActionTypes.EDIT_MAILING_LIST,
        payload: {
            mailingList,
            id
        }
    }),

    addMailingList: ({ mailingList }) => ({
        type: MailingActionTypes.ADD_MAILING_LISTS,
        payload: {
            mailingList
        }
    }),

    clearMailingList: () => ({
        type: MailingActionTypes.CLEAR_MAILING_LISTS
    }),

    clearSubmitMailingList: () => ({
        type: MailingActionTypes.CLEAR_SUBMIT_MAILING_LIST
    }),


    activateMailingList: mailing => ({
        type: MailingActionTypes.TOGGLE_MAILING_LIST_ACTIVE,
        payload: {
            active: true,
            mailingList: mailing
        }
    }),

    deactivateMailingList: mailing => ({
        type: MailingActionTypes.TOGGLE_MAILING_LIST_ACTIVE,
        payload: {
            active: false,
            mailingList: mailing
        }
    }),
};
